<!--
Menu item

Main menu dropdowns
-->
<template>
	<OnClickOutside @trigger="closeDropdown()">
		<FocusLock :disabled="!open">
			<li class="c-menu-item" ref="item">
				<button
					v-if="hasSubitems"
					@click="toggleDropdown()"
					class="c-menu-item__toggle"
					:class="{ 'is-active': open }"
					:id="toggleId()"
					aria-haspopup="true"
					:aria-controls="dropdownId()"
				>
					{{ label }}<slot name="tab-icon"></slot>
				</button>

				<a v-else :href="link" class="c-menu-item__link" :class="{ 'is-active': isActive}">
					{{ label }}
				</a>

				<Transition name="menu-item">
					<div v-if="hasSubitems && open"
						class="c-menu-item__dropdown"
						:class="dropdownClass"
						:id="dropdownId()"
						role="menu"
						:aria-labelledby="toggleId()"
					>
						<button
							@click="closeDropdown()"
							aria-label="Close sub-menu"
							class="c-menu-item__close o-button o-button--secondary"
						>
							<slot name="close">Close</slot>
						</button>
						<a v-if="link" :href="link" class="c-menu-item__title o-nav__link">
							{{ label }}<slot name="title-icon"></slot>
						</a>
						<span v-else class="c-menu-item__title">
							{{ label }}
						</span>
						<ul class="c-menu-item__list">
							<slot name="pages"></slot>
						</ul>
					</div>
				</Transition>
			</li>
		</FocusLock>
	</OnClickOutside>
</template>

<script>
	import { OnClickOutside } from '@vueuse/components';
	import FocusLock from 'vue-focus-lock';

	export default {
		name: "menu-item",
		data() {
			return {
				open: false
			};
		},
		components: {
			OnClickOutside,
			FocusLock
		},
		props: {
			label: {
				type: String,
			},
			link: {
				type: String,
			},
			id: {
				type: String,
			},
			dropdownClass: {
				type: String,
			},
			hasSubitems: {
				type: Boolean,
				default: false
  			},
			isActive:{
				type: Boolean,
				default: false
			},
			cta:{
				type: Boolean,
				default: false	
			},
		},
		methods: {
			toggleDropdown() {
				this.open = !this.open;
			},
			closeDropdown() {
				this.open = false;
			},
			toggleId() {
				return `menu-toggle-${this.id}`
			},
			dropdownId() {
				return `menu-dropdown-${this.id}`
			}
		}
	};
</script>
